import Http from "./http-service";

import { PRIVATE_API_ROUTES } from "../constants";
import {
  getProductCategoryById,
  getProductCategoryList,
} from "../globalContext/productCategory/productCategoryActions";
import { showNotification } from "../UtilityFunctions/notification";
import {
  downloadReports,
  getLocalizedMessage,
  hideLoaderShowErrorMsg,
} from "../UtilityFunctions/utils";
import {
  PRODUCT_CATEGORY_ADD_INVALID_INPUT,
  UNIQUE_DATA_REQUIRE,
} from "../constants/errorConstants";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";

class ProductCategoryService {
  static async getProductCategoryList(
    dispatch,
    queryParams,
    intl,
    loaderDispatch
  ) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.PRODUCT_CATEGORY, queryParams)
      .then((res) => {
        dispatch(getProductCategoryList(res?.data?.data));
        loaderDispatch(setLoading(false));
      })
      .catch((err) => {
        hideLoaderShowErrorMsg({ loaderDispatch, intl, setLoading });
      }); // Http.post(`/users/sign-in`, body)
  }

  static getCountries(intl) {
    return Http.get(PRIVATE_API_ROUTES.COUNTRY)
      .then((res) => {
        return res?.data?.data;
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
      });
  }

  static addProductCategory(loaderDispatch, body, navigate, intl, resetForm) {
    loaderDispatch(setLoading(true));
    return Http.post(PRIVATE_API_ROUTES.PRODUCT_CATEGORY, body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "productCategory.productCategoryAdded")
        );
        navigate("/product-category");
        resetForm();
      })
      .catch((err) => {
        loaderDispatch(setLoading(false)); //button.text.addProductCategory
        if (err?.response?.data?.code === PRODUCT_CATEGORY_ADD_INVALID_INPUT) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.productCategoryInValidInput")
          );
        } else if (err?.response?.data?.code === UNIQUE_DATA_REQUIRE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.productCategory.unique", {
              subCategory: err?.response?.data?.message?.match(/=\((.*?)\)/)[1],
            })
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
      });
  }

  static async getProductCategoryById(
    dispatch,
    loaderDispatch,
    productCategoryId,
    intl
  ) {
    loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.PRODUCT_CATEGORY}/${productCategoryId}`
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        if (dispatch) {
          dispatch(getProductCategoryById(res?.data?.data));
        } else {
          return Promise.resolve(res?.data?.data?.result?.[0]);
        }
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }

  static markActiveInactive(body, intl) {
    return Http.put(PRIVATE_API_ROUTES.PRODUCT_SUBCATEGORY, body)
      .then((res) => {
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "savedSuccessFully")
        );
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      }); // Http.post(`/users/sign-in`, body)
  }

  static editProductCategory(loaderDispatch, body, navigate, intl, resetForm) {
    loaderDispatch(setLoading(true));
    return Http.put(PRIVATE_API_ROUTES.PRODUCT_CATEGORY, body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "productCategory.productCategoryUpdated")
        );
        navigate("/product-category");
        resetForm();
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === PRODUCT_CATEGORY_ADD_INVALID_INPUT) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.productCategoryInValidInput")
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
      });
  }

  static async getDownloadProductCategoryReports({
    params,
    intl,
    loaderDispatch,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      PRIVATE_API_ROUTES.DOWNLOAD_PRODUCT_REPORTS,
      params,
      () => {}, //NOSONAR
      "blob"
    )
      .then((response) => {
        loaderDispatch(setLoading(false));
        downloadReports(response);
      })
      .catch(() => {
        hideLoaderShowErrorMsg({ loaderDispatch, intl, setLoading });
      });
  }
}

export default ProductCategoryService;
